const utils = require('../../utils')

export default {
  name: 'es-mycard-preview',
  data: () => ({
    card: {},
    savingFlag: false,
    isHandOverCardCompleteModal: false,
    isHandOverCardErrorModal: false
  }),
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    // 背景画像パス生成
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    // プロフィール画像パス生成
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${this.authToken}&timestamp=${this.timeStamp}`
        }
        return require('../images/img_profile.png')
      }
    },
    // キャラクター画像パス生成
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    },
    // キャラクター画像パス生成
    getCharacter2ImageByImageName () {
      return (imageName) => {
        return require(`../../../static/mycard/character2/${imageName}.png`)
      }
    }
  },
  created: async function () {
    // 初期表示処理
    await this.setInitializ()
  },
  methods: {
    goBack () {
      // 戻る：カード作成画面へ
      this.$router.push({ path: '/es_mycard/new' })
    },
    goEsMycardList () {
      // ESmyカード一覧へ
      this.isHandOverCardCompleteModal = false
      this.isHandOverCardErrorModal = false
      this.$router.push({ path: '/es_mycard_list'})
    },
    goCancel () {
      this.isHandOverCardErrorModal = false
      this.goBack()
    },
    async setHandOver () {
      // ボタン連打時に複数カードが登録されないように制御
      if (this.savingFlag) return
      this.savingFlag = true
      // 入力内容設定
      const formData = new FormData()
      formData.append('get_user_id', this.card.get_user_id)
      formData.append('give_user_id', this.card.give_user_id)
      formData.append('is_facing_type', 0)
      formData.append('is_already_read', 0)
      formData.append('background_path', this.card.background_path)
      formData.append('character_1_folder_path', this.card.character_1_folder_path)
      formData.append('character_1_path', this.card.character_1_path)
      formData.append('character_2_path', this.card.character_2_path)
      // 保存できない4バイト文字(絵文字)が残っていると登録エラーになるため送信直前にも除去する
      formData.append('comments', utils.removeEmoji(this.card.comments))
      formData.append('idea_peace_ming', this.card.idea_peace_ming ? 1 : 0)
      formData.append('idea_sincere', this.card.idea_sincere ? 1 : 0)
      formData.append('idea_excitement', this.card.idea_excitement ? 1 : 0)
      formData.append('idea_comfortable', this.card.idea_comfortable ? 1 : 0)
      formData.append('idea_creation', this.card.idea_creation ? 1 : 0)
      formData.append('idea_civility', this.card.idea_civility ? 1 : 0)
      formData.append('idea_imagination', this.card.idea_imagination ? 1 : 0)
      formData.append('idea_sympathy', this.card.idea_sympathy ? 1 : 0)
      formData.append('idea_expression', this.card.idea_expression ? 1 : 0)
      formData.append('idea_challenge_dream', this.card.idea_challenge_dream ? 1 : 0)
      formData.append('base_url', process.env.ASOVI_URL)
      // カード情報登録
      try {
        const res = await this.$store.dispatch('CARD_CREATE', formData)
        if (res === 'error') {
          // サーバー側で登録に失敗している
          this.isHandOverCardErrorModal = true
          return
        }
        // SessionStorageを削除
        sessionStorage.removeItem('es_mycard')
        // 登録完了モーダル表示
        this.isHandOverCardCompleteModal = true
      } catch (err) {
        // 通信エラー時はカードが登録されていないため、完了ではなくエラーとして扱う
        // (旧実装ではエラーを握りつぶして完了モーダルを表示していた)
        console.error(err)
        this.isHandOverCardErrorModal = true
      } finally {
        // 失敗した場合にもう一度送信できるよう、連打防止フラグを必ず戻す
        // (旧実装では戻していなかったため、1度失敗すると再読み込みするまで送信できなかった)
        this.savingFlag = false
      }
    },
    setClassCommentFontSize () {
      // 入力された文字によってスタイル変更
      if (this.card.comments.length <= 50) {
        return 'big'
      }
      if (this.card.comments.length <= 80) {
        return 'middle'
      }
      if (this.card.comments.length <= 140) {
        return 'small'
      }
    },
    setInitializ: async function () {
      // Session Storageデータを設定
      this.card = JSON.parse(window.sessionStorage.getItem('es_mycard'))
    },
    saveDraft: function () {
      const draftData = {
        get_user_id: this.card.get_user_id,
        get_user_image: this.card.get_user_image,
        get_user_shop_name: this.card.get_user_shop_name,
        get_user_name: this.card.get_user_name,
        is_facing_type: 0,
        is_already_read: 0,
        background_path: this.card.background_path,
        character_1_folder_path: this.card.character_1_folder_path,
        character_1_path: this.card.character_1_path,
        character_2_path: this.card.character_2_path,
        comments: this.card.comments,
        idea_peace_ming: this.card.idea_peace_ming,
        idea_sincere: this.card.idea_sincere,
        idea_excitement: this.card.idea_excitement,
        idea_comfortable: this.card.idea_comfortable,
        idea_creation: this.card.idea_creation,
        idea_civility: this.card.idea_civility,
        idea_imagination: this.card.idea_imagination,
        idea_sympathy: this.card.idea_sympathy,
        idea_expression: this.card.idea_expression,
        idea_challenge_dream: this.card.idea_challenge_dream
      }
      localStorage.setItem('es_mycard_draft', JSON.stringify(draftData))
      alert('下書きを保存しました')
      this.$router.push({ path: '/' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-preview.js